import { Tag } from "antd";
import { excludeFilterProperties } from "helpers/ExcludeAdvertFilter";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { handleSetAdvertListFilter } from "../ClientStates";
import { FC } from "react";
import { useLocation } from "react-router-dom";

const FilterTags: FC<{ isMobile: boolean }> = ({ isMobile }) => {
  const { filter } = useSelector((state: RootState) => state.realState);

  const location = useLocation();
  const dispatch = useDispatch();



  // // Location state'inden filtre bilgilerini al
  // const locationState = location.state as {
  //   locationInfo?: {
  //     type: 'city' | 'district' | 'neighbourhood';
  //     id: number;
  //     name: string;
  //   };
  //   cityId?: number;
  //   cityName?: string;
  //   districtId?: number;
  //   districtName?: string;
  //   neighbourhoodId?: number;
  //   neighbourhoodName?: string;
  // };

  // Location bilgilerini kaldırma fonksiyonu
  // const handleRemoveLocationFilter = (type: 'city' | 'district' | 'neighbourhood') => {
  //   const newFilter = { ...filter };

  //   if (type === 'city') {
  //     delete newFilter.CityId;
  //     delete newFilter.DistrictIds;
  //     delete newFilter.NeighbourhoodIds;
  //   } else if (type === 'district') {
  //     delete newFilter.DistrictIds;
  //     delete newFilter.NeighbourhoodIds;
  //   } else if (type === 'neighbourhood') {
  //     delete newFilter.NeighbourhoodIds;
  //   }

  //   dispatch(handleSetAdvertListFilter({ filter: newFilter }));
  // };

  const handleOnCloseFilterProperties = (e: any, key: any) => {
    const currenctFilter = { ...filter };

    if (key === "stateProvinceName") {
      delete currenctFilter["CityId"];
    }

    else if (key === "currencyName") {
      delete currenctFilter["CurrencyId"];
    } else if (key === "eidsTypeName") {
      delete currenctFilter["EidsApproved"];
    }

    delete currenctFilter[key];
    dispatch(handleSetAdvertListFilter({ filter: currenctFilter }));
    e.preventDefault();
  };


  const handleCloseOptionProperties = (
    e: React.MouseEvent,
    optionKey: number,
    valueKey: number
  ) => {
    e.preventDefault();

    const currentFilter = { ...filter };
    const selectedAllOptions = filter?.selectedOptionListObj || [];
    let allOptionStringData = filter?.SelectedOptionList || "";

    const replacedOptionString = `${optionKey}:${valueKey}`;

    let updatedOptionList = allOptionStringData
      .split(",")
      .filter((item: any) => item !== replacedOptionString) // Seçili olanı kaldır
      .join(",");

    updatedOptionList = updatedOptionList.replace(/^,|,$/g, "");

    if (updatedOptionList) {
      currentFilter["SelectedOptionList"] = updatedOptionList;
    } else {
      delete currentFilter["SelectedOptionList"];
    }

    const updatedOptions = selectedAllOptions
      .map((option: any) => {
        if (option.key === optionKey) {
          const updatedValues = option.values.filter((v: any) => v.key !== valueKey);
          return updatedValues.length > 0 ? { ...option, values: updatedValues } : null;
        }
        return option;
      })
      .filter((option: any) => option !== null);

    if (updatedOptions.length > 0) {
      currentFilter["selectedOptionListObj"] = updatedOptions;
    } else {
      delete currentFilter["selectedOptionListObj"];
    }

    dispatch(handleSetAdvertListFilter({ filter: currentFilter }));
  };


  const handleOnCloseDistrictFilterProperties = (e: any, keyToRemove: string,) => {
    e.preventDefault();
    let newDistrictName = filter.districtNames.filter(
      (item: any) => item.key !== keyToRemove
    )
    let newDistrictIds = filter.DistrictIds.filter((id: any) => id !== keyToRemove)
    let currentFilter = {
      ...filter,

    }
    if (newDistrictIds.length > 0) {
      currentFilter["districtNames"] = newDistrictName
      currentFilter["DistrictIds"] = newDistrictIds
    }
    else {
      delete currentFilter["districtNames"]
      delete currentFilter["DistrictIds"]
    }


    dispatch(handleSetAdvertListFilter({ filter: currentFilter }))
  };

  const handleOnCloseNeighbourhoodFilterProperties = (e: any, indexToRemove: number) => {
    e.preventDefault();
    if (!filter?.NeighbourhoodIds || !filter?.neighbourhoodNames) return;

    let newNeighbourhoodNames = filter.neighbourhoodNames.filter((_: string, index: number) => index !== indexToRemove);
    let newNeighbourhoodIds = filter.NeighbourhoodIds.filter((_: string, index: number) => index !== indexToRemove);

    let currentFilter = {
      ...filter,
      NeighbourhoodIds: newNeighbourhoodIds,
      neighbourhoodNames: newNeighbourhoodNames,
    };

    dispatch(handleSetAdvertListFilter({ filter: currentFilter }));
  };
  console.log("FilterTags",filter)

  return (
    <>

      {/* {locationState?.cityId && (
        <Tag
          closable
          onClose={(e) => {
            e.preventDefault();
            handleRemoveLocationFilter('city');
          }}
        >
           {locationState.cityName}
        </Tag>
      )}
      
      {locationState?.districtId && (
        <Tag
          closable
          onClose={(e) => {
            e.preventDefault();
            handleRemoveLocationFilter('district');
          }}
        >
           {locationState.districtName}
        </Tag>
      )}
      
      {locationState?.neighbourhoodId && (
        <Tag
          closable
          onClose={(e) => {
            e.preventDefault();
            handleRemoveLocationFilter('neighbourhood');
          }}
        >
           {locationState.neighbourhoodName}
        </Tag>
      )} */}

      {Object.entries(filter)?.length && (
        <>
          {Object.entries(excludeFilterProperties(filter, isMobile)).map(
            ([key, value]) => {
              return (
                <>

                  <Tag
                    onClose={(e) => {
                      handleOnCloseFilterProperties(e, key);
                    }}
                    closable={true}
                  >{`${value}`}</Tag>
                </>
              );
            }
          )}
        </>
      )}

      {Object.entries(filter)?.length && (
        <>
          {
            filter?.districtNames?.map((item: any) => {

              return (
                <>
                  <Tag
                    onClose={(e) => {
                      handleOnCloseDistrictFilterProperties(e, item.key);
                    }}
                    closable={true}
                  >{item}</Tag>
                </>
              )
            })
          }
        </>
      )}


      <>
        {
          filter?.neighbourhoodNames?.map((item: any, index: number) => {

            return (
              <>
                <Tag
                  onClose={(e) => {
                    handleOnCloseNeighbourhoodFilterProperties(e, index)
                  }}
                  closable={true}
                >{item}
                </Tag>
              </>
            )
          })
        }
      </>


{filter?.selectedOptionListObj && (
  <>
    {filter?.selectedOptionListObj
      .filter((item: any) => item.values)
      .map((item: any) => {
        return (
          <>
            {item.values.map((subItem: any) => {
              return (
                <Tag
                  closable
                  onClose={(e) => {
                    handleCloseOptionProperties(
                      e,
                      item.key,
                      subItem.key
                    );
                  }}
                >
                  {subItem.name || subItem.value || subItem.key}
                </Tag>
              );
            })}
          </>
        );
      })}
  </>
)}

    </>
  );
};

export default FilterTags;
